import {Action, createReducer, on} from '@ngrx/store';
import * as fromActions from './newsletter-websocket.actions';
import {createEntityAdapter, Dictionary, EntityAdapter, EntityState} from '@ngrx/entity';

export interface SharedNewsletter {
  newsletterId: number;
  workInProgress: boolean;
  workingUserLogin: string;
  workingUserFullName: string;
}

export interface State {
  isWebSocketConnected: boolean;
  newsletters: EntityState<SharedNewsletter>;
}

export const adapter: EntityAdapter<SharedNewsletter> =
 createEntityAdapter<SharedNewsletter>({
  selectId: newsletter => newsletter.newsletterId
 });

export const initialState: State = {
  isWebSocketConnected: false,
  newsletters: {...adapter.getInitialState()},
};

export const newsletterWebSocketReducer = createReducer(
  initialState,
  on(fromActions.wsSetIsConnected, (state) => ({
    ...state,
    isWebSocketConnected: true
  })),
  on(fromActions.wsDisconnected, (state) => ({
    ...state,
    isWebSocketConnected: false,
    newsletters: {...adapter.getInitialState()}
  })),
  on(fromActions.wsNewsletterInfo, (state, {newsletters}) => ({
    ...state,
    newsletters: adapter.addMany(newsletters, state.newsletters)
  })),
  on(fromActions.wsNewsletterTaken, fromActions.wsNewsletterReleased, (state, {newsletter}) => ({
    ...state,
    newsletters: adapter.upsertOne(newsletter, state.newsletters)
  })),
  )
;

export function reducer(state: State | undefined, action: Action) {
  return newsletterWebSocketReducer(state, action);
}

export const getNewsletters = (state: State) => state.newsletters;
export const getIsWebSocketConnected = (state: State) => state.isWebSocketConnected;
export const getIds = adapter.getSelectors().selectIds;
export const getEntities = adapter.getSelectors().selectEntities;
export const getAll = adapter.getSelectors().selectAll;
export const getTotal = adapter.getSelectors().selectTotal;

export const getEntityById = (entities: Dictionary<SharedNewsletter>, {id}) => entities[id];
export const getEntitiesById = (entities: Dictionary<SharedNewsletter>, {ids}) => ids.map(id => entities[id]);
